import * as React from 'react';
import { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Button, { ButtonFont, ButtonSize, ButtonType } from 'src/components/Button';
import actions from 'src/app/redux/store/actions';
import selectors from 'src/app/redux/selectors';
import styles from './RefreshSessionTimeoutModal.css';

const RefreshSessionTimeoutModal: FunctionComponent = () => {

  const intl = useIntl();
  const show = useSelector(selectors.auth.notifyTokenTimeout);
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(actions.auth.notifyTokenTimeout(false));
  };
  const onConfirm = () => {
    dispatch(actions.auth.updateRefreshTimeoutToken());
    onClose();
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
    >
      <Modal.Header>
        <Modal.Title>
          {intl.formatMessage({ id: 'MursionPortal.Modal.Header.SessionTimeout' })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {intl.formatMessage({ id: 'MursionPortal.Modal.Body.SessionTimeout' })}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <div
          className={styles.confirmationBtns}
        >
          <Button
            btnSize={ButtonSize.MEDIUM}
            btnFont={ButtonFont.LIGHT}
            onClick={onClose}>
            {intl.formatMessage({ id: 'MursionPortal.Button.Cancel' })}
          </Button>
          <Button
            btnSize={ButtonSize.MEDIUM}
            btnFont={ButtonFont.LIGHT}
            btnType={ButtonType.SPECIAL_PURPLE}
            onClick={onConfirm}>
            {intl.formatMessage({ id: 'MursionPortal.Button.Continue' })}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default RefreshSessionTimeoutModal;